import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard  from './components/Dashboard';
import Plates  from './components/Plates';
import Journal  from './components/Journal';
import './App.css';
import Navigation from './components/Navigation';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ruRU } from '@mui/x-date-pickers/locales';

const theme = createTheme(
  {
    palette: {
      primary: { main: '#1976d2' },
    },
  },
  ruRU, // use 'de' locale for UI texts (start, next month, ...)
);

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }
  
  if (!user) {
    // Сохраняем текущее местоположение, чтобы вернуться после логина
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }
  
  // Если пользователь авторизирован, перенаправляем на главную
  if (user) {
    const from = location.state?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }
  
  return children;
};

function AppContent() {
  const { user, logout } = useAuth();

  return (
    <div className="App">
      { user && <Navigation></Navigation> }
      
      <main>
        <Routes>
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } 
          />
          {/*}
          <Route 
            path="/register" 
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            } 
          />
          {*/}
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/plates" 
            element={
              <PrivateRoute>
                <Plates />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/journal" 
            element={
              <PrivateRoute>
                <Journal />
              </PrivateRoute>
            } 
          />
          {/*}
          <Route 
            path="/contact" 
            element={
              <PrivateRoute>
                <Contacts />
              </PrivateRoute>
            } 
          />
          {*/}
          {/* Добавляем fallback для несуществующих путей */}
          <Route path="/home" element={<Navigate to="/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <title>ИИСКУД</title>
        <link rel="icon" href="logo.png"></link>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
